import fetch from '@/utils/fetch'

export const List = '/secure/black_address/lists'

export function handleExport (query) {
  return fetch({
    url: List,
    method: 'get',
    params: query
  })
}

export function create (data) {
  return fetch({
    url: '/secure/black_address/add',
    method: 'post',
    data
  })
}

export function update (data) {
  return fetch({
	  url: '/secure/black_address/update',
	  method: 'post',
	  data
  })
}
export function detail (id) {
  return fetch({
	  url: '/secure/black_address/delete',
	  method: 'post',
	  data: {
      id
    }
  })
}

export function batchDelete (ids) {
  return fetch({
    url: '/secure/black_address/delete',
    method: 'post',
    data: {
      ids
    }
  })
}

export function getOpList (params) {
  return fetch({
    url: '/secure/black_address/operation/lists',
    method: 'get',
    params
  })
}

export function batchOpDis (ids, disabled) {
  return fetch({
    url: '/secure/black_address/disabled/batch',
    method: 'post',
    data: {
      ids,
      disabled
    }
  })
}
